import { render } from "./ClickBankProduct.vue?vue&type=template&id=d3a3020a"
import script from "./ClickBankProduct.vue?vue&type=script&lang=js"
export * from "./ClickBankProduct.vue?vue&type=script&lang=js"
script.render = render

export default script